module.exports = __webpack_public_path__ + "media/images/payment_image-d0236be858f12e4bfcb4466d66021cd2.png";